import { Pagination } from '$core/models/pagination';
import { TitleCasePipe } from '@angular/common';

const titleCasePipe = new TitleCasePipe();

export namespace OldAddressBook {
  export class ComplexCity {
    public region: string | null;
    public district: string | null;
    public city: string;

    public name: string;
    public value: string;

    constructor(data: ComplexCity) {
      for (const key of Object.keys(data)) {
        if (data[key]) {
          data[key] = titleCasePipe.transform(data[key]);
        }
      }
      Object.assign(this, data);
      this.value = this.city;
      this.name = this.value;
    }
  }

  export class ComplexStreet {
    public city_type: string;
    public street_type: string;
    public street: string;

    public name: string;
    public value: string;

    constructor(data: ComplexStreet) {
      if (data.street) {
        data.street = titleCasePipe.transform(data.street);
      }
      Object.assign(this, data);
      this.value = data.street;
      this.name = this.value;
    }
  }

  export class ComplexAddress {
    public region: string | null;
    public district: string | null;

    private _complexCity: ComplexCity;
    public get complexCity() {
      return this._complexCity;
    }
    public set complexCity(value) {
      this.region = value ? value.region : null;
      this.district = value ? value.district : null;
      this._complexCity = value;
    }

    private _complexStreet: ComplexStreet;
    public get complexStreet() {
      return this._complexStreet;
    }
    public set complexStreet(value) {
      this._complexStreet = value;
    }

    // Arrays of Data

    private _complexCities: Pagination<ComplexCity>;
    public get complexCities() {
      return this._complexCities;
    }
    public set complexCities(v) {
      this._complexCities = v;
    }

    private _complexStreets: Pagination<ComplexStreet>;
    public get streets() {
      return this._complexStreets;
    }
    public set streets(v) {
      this._complexStreets = v;
    }
  }
}
